<template>
  <div class="dialogs-box">
    <div class="title-row" v-if="!loadingTags">Check out some of our dialogues</div>
    <div class="tags-row" v-if="!loadingTags">
      <span>Search by tag:</span>
      <Tag :name="tag.tagName" :selected="selectedTag" :index="index" v-for="(tag, index) in tags" :key="index" @select="selectedTag = index"/>
    </div>
    <div class="dialogs-row" v-if="!loadingTags">
      <DialogFrame class="desktop" v-for="dialog in getTagDialogs" :dialogId="dialog.dialogueId" :key="dialog.dialogueId"/>
      
      <carousel-3d class="mobile" :controls-visible="true" :clickable="false" :autoplay="false" :autoplay-timeout="4000" :perspective="0">
        <slide class="slide" v-for="(slide, i) in getTagDialogs" :index="i" :key="slide.dialogueId">
          <DialogFrame :dialogId="slide.dialogueId"/>
        </slide>
      </carousel-3d>
    </div>
    <div class="see-more-row" v-if="!loadingTags">
      <button @click="onSeeMore">
        See more
        <font-awesome-icon icon="angle-double-right" class="icon"/>
      </button>
    </div>
    <div class="loading-box" v-if="loadingTags">
      <Loader/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Tag from './Tag'
import DialogFrame from './DialogFrame'
import { Carousel3d, Slide } from 'vue-carousel-3d';
import Loader from '../Loader'

export default {
  name: 'DialogsBox',
  data() {
    return {
      tags: [],
      selectedTag: 0,
      loadingTags: true
    }
  },
  components: {
    Tag,
    DialogFrame,
    Carousel3d,
    Slide,
    Loader
  },
  methods: {
    loadDialogues() {
      axios({
        method: "POST",
        url: "https://graphql.datocms.com",
        headers: {
          Authorization: 'bearer ' + 'a80e7c69e34cfcc1afa81f28c89c42'
        },
        data: {
          query: `
            {
              allHomeDialogues {
                tagName
                dialogues {
                  dialogueId
                }
              }
            }
          `
        }
      }).then(result => {
        this.tags = result.data.data.allHomeDialogues;
        this.loadingTags = false;
      }).catch(err => {
        console.log(err);
        this.loadingTags = false;
      });
    },
    onSeeMore() {
      let tagName = this.tags[this.selectedTag].tagName;
      if(this.TokenState) {
        this.$router.push({ path: '/main', query: { 'search': tagName } });
      } else {
        this.$emit('openSeeMoreBox');
      }
    }
  },
  computed: {
    getTagDialogs() {
      return this.tags[this.selectedTag].dialogues;
    },
    getSliderSpace() {
      if(window.innerWidth >= 950){
        return 350;
      } else {
        return 300;
      }
    },
    TokenState() {
      if(localStorage.getItem('token') != null) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentTag() {
      return this.tags[this.selectedTag].tagName;
    }
  },
  mounted() {
    this.loadDialogues();
  }
}
</script>

<style lang="scss" scoped>
.dialogs-box {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 2.5rem;

  @media (max-width: 600px) {
    padding-bottom: 2.5rem;
  }
}

.loading-box {
  width: 100%;
  min-height: 25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
  @media (max-width: 600px) {
    margin-top: 2rem;
  }
}

.title-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  font-weight: bold;
  color: #a0a0a0;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-top: 3rem;
  @media (max-width: 550px) {
    font-size: 1.8rem;
  }
  @media (max-width: 450px) {
    font-size: 1.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 2rem;
  }
  @media (max-width: 400px) {
    text-align: center;
  }
}

.tags-row {
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 550px) {
    flex-wrap: wrap;
    height: auto;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  span {
    font-size: 1.4rem;
    color: #bebebe;
    margin-right: 0.4rem;
    @media (max-width: 700px) {
      display: none;
    }
  }
}

.dialogs-row {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;

  @media (max-width: 600px) {
    flex-direction: column;
  }

  .desktop {
    display: inline;
    @media (max-width: 1300px) {
      display: none;
    }
    @media (max-width: 600px) {
      display: inline;
    }
  }

  .mobile {
    display: none;
    @media (max-width: 1300px) {
      display: inline;
    }
    @media (max-width: 600px) {
      display: none;
    }
  }

  .carousel-3d-container {
    width: 60rem !important;
    height: 16rem !important;
    @media (max-width: 1000px) {
      width: 98% !important;
    }
  }

  .carousel-3d-slide {
    width: 25rem !important;
    height: 16rem !important;
    border: none !important;
    border-radius: 0.3rem;
    margin-left: -1rem !important;
  }

  .left-1 {
    transform: translateX(-350px) translateZ(-400px) rotateY(0deg) !important;
    @media (max-width: 950px) {
      transform: translateX(-300px) translateZ(-400px) rotateY(0deg) !important;
    }
    @media (max-width: 850px) {
      transform: translateX(-250px) translateZ(-400px) rotateY(0deg) !important;
    }
    @media (max-width: 780px) {
      transform: translateX(-200px) translateZ(-400px) rotateY(0deg) !important;
    }
    @media (max-width: 680px) {
      transform: translateX(-150px) translateZ(-400px) rotateY(0deg) !important;
    }
  }
  .right-1 {
    transform: translateX(350px) translateZ(-400px) rotateY(0deg) !important;
    @media (max-width: 950px) {
      transform: translateX(300px) translateZ(-400px) rotateY(0deg) !important;
    }
    @media (max-width: 850px) {
      transform: translateX(250px) translateZ(-400px) rotateY(0deg) !important;
    }
    @media (max-width: 780px) {
      transform: translateX(200px) translateZ(-400px) rotateY(0deg) !important;
    }
    @media (max-width: 680px) {
      transform: translateX(150px) translateZ(-400px) rotateY(0deg) !important;
    }
  }
}

.see-more-row {
  width: 100%;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  font-size: 1.5rem;
  color: #a0a0a0;

  @media (max-width: 600px) {
    margin-top: 2rem;
  }

  button {
    border: none;
    outline: none;
    background-color: #0EA89A;
    color: #F4F4F4;
    width: 10rem;
    height: 2.5rem;
    font-size: 1.2rem;
    border-radius: 0.2rem;
    transition: 0.3s;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }

  .icon {
    margin-left: 0.2rem;
    padding-top: 0.2rem;
  }
}
</style>